import React from 'react'
import { Container, Typography } from '@material-ui/core'
import { List, ListItem, ListItemText } from '@mui/material'
import makeStyles from './style'


export default function Servicos() {
    const {bigContainer, container, title, description} = makeStyles()

    const areas = ['Setor Têxtil', 'Setor Automobilístico', 'Petroquímica', 'Setor prod. de máquinas', 'Setor Agrícola', 'Manutenção Industrial']

    return (
        <Container className={bigContainer}>
            <Container className={container}>
                <Typography gutterBottom variant='h4' component='div' className={title}>
                Áreas de atuação
                </Typography>
                <List>
                    <li>
                    <ul>
                        {areas.map((item, index) => (
                        <ListItem key={index}>
                            <ListItemText primary={item} />
                        </ListItem>
                        ))}
                    </ul>
                    </li>
                </List>
            </Container>
            <Container className={container}>
                <Typography gutterBottom variant='h4' component='div' className={title}>
                Nossos serviços
                </Typography>
                <Typography gutterBottom variant='h5' component='div' className={title}>
                Nosso Trabalho
                </Typography>
                <Typography variant='body2' color='text.secondary' className={description}>
                Nossos produtos são elaborados de acordo com as normas e exigências dos nossos clientes, inclusive quanto ao fornecimento do material.
                <br /> 
                <br /> 
                Nossos fornecedores atendem a todas as especificações necessárias dos materiais ou componentes especificados em nosso pedido de compras. 
                <br />
                <br />
                Os materiais são recebidos e inspecionados na nossa empresa ou nos fornecedores, e quando necessário são realizados ensaios por terceiros.
                <br/>
                <br/>
                Todas as peças enviadas para produção são acompanhas de ordem de produção, ciclo de trabalho e cópia de desenho emitidas pelo PCP, onde constam todas as informações necessárias para a execução dos trabalhos a serem executados.
                <br />
                <br />
                As máquinas CNC tem seus programas de usinagem armazenados em CPU e todas as operações são inspecionadas durante e após o termino da usinagem pelo nosso controle de qualidade onde é realizada a inspeção final do produto e emitido o relatório de qualidade.
                </Typography>
            </Container>
        </Container>
    )
}